import { FormsData, SubFormsDataTypes } from "../../models/forms";
import { ProgramsDataResponse } from "../../server/crm/api/models/forms";
import { OnboardingRootState } from "../reducers/rootReducer";
import { getOnboardingState } from "./rootSelectors";
import { getCurrentProgram } from "./statusSelectors";

export const getCurrentProgramData = (state: OnboardingRootState): ProgramsDataResponse =>
  getOnboardingState(state).programs[getCurrentProgram(state)];

export const getFormData = (state: OnboardingRootState, formId: string): FormsData =>
  getCurrentProgramData(state)?.forms[formId];

export const getSubFormData = (
  state: OnboardingRootState,
  formId: string,
  subFormId: string
): SubFormsDataTypes => {
  const form = getFormData(state, formId);
  return form?.subForms[subFormId] ?? undefined;
};
